module.exports = "https://static.wagwalking.com/_next/static/images/vet-assistant-notification@2x-9ee3946e3a07f6da8c817e63cb7c5be2.png";